import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dataModel from '../../models/DataModel';
import _ from 'lodash';
import BaseComponent from '../../baseClasses/BaseComponent';
import anime from 'animejs';
import cancelIcon from '../../assets/images/close-icon.svg';
import DataSource from '../../dao/DataSource/DataSource';
import UserAvatar from '../../components/UserAvatar';
// import CheckBox from '../../components/CheckBox'

import './QuickerAssignPopup.scss';

class QuickerAssignPopup extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      mode: 'usersOnly',
    };

    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.createUserAssignments = this.createUserAssignments.bind(this);
  }

  handleProjectRetrieval(project) {
    if (project) {
      this.setState({ project });
    }
  }

  componentDidMount() {
    dataModel.setDisableAppBackground(true);
    this.expandPopup();

    this.projectDataSource = new DataSource('Project', this.props.projectId, {
      project: {
        users: { additionalFields: ['profile_image'], role: {}, companies: {} },
      },
    },
      this.handleProjectRetrieval);
    this.projectDataSource.get();

    if (this.props.selectedUser) {
      this.handleUserSelected(this.props.selectedUser);
    }
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleModeToggle() {
    let mode = '';
    if (this.state.mode == 'multipleAssignmentTypes') {
      mode = 'usersOnly';
    }
    else {
      mode = 'multipleAssignmentTypes';
    }
    this.setState({ active: false, mode, assignmentType: null, quickAssignments: null });
  }

  expandPopup() {
    return anime({
      targets: this.quickerAssignPopup,
      height: 517,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e, force) {
    return anime({
      targets: this.quickerAssignPopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
  } 
  
  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleSelectAssignmentType(newAssignmentType) {
    let { assignmentType, quickAssignments, mode } = this.state;
    let active = false;
    if (!quickAssignments) {
      quickAssignments = {};
    }
    if (mode == 'usersOnly') {
      if (assignmentType == newAssignmentType) {
        if (quickAssignments) {
          quickAssignments['none'] = Object.assign({}, quickAssignments[assignmentType]);
          delete quickAssignments[assignmentType];
        }
        newAssignmentType = null;
      }
      else {
        if (quickAssignments && quickAssignments['none']) {
          assignmentType = 'none';
        }
        if (assignmentType && assignmentType != newAssignmentType) {
          quickAssignments[newAssignmentType] = Object.assign({}, quickAssignments[assignmentType]);
          delete quickAssignments[assignmentType];
        }
      }
    }
    else if (quickAssignments) {
      for (let key in quickAssignments) {
        if (key) {
          active = active || !_.isEmpty(quickAssignments[key]);
        }
      }
    }
    if (quickAssignments && quickAssignments[newAssignmentType]) {
      active = active || !_.isEmpty(quickAssignments[newAssignmentType]);
    }
    this.setState({ assignmentType: newAssignmentType, active });
  }

  handleUserSelected(user) {
    let { quickAssignments, assignmentType, mode } = this.state;
    if (!assignmentType && mode == 'usersOnly') {
      assignmentType = 'none';
    }

    if (assignmentType) {
      if (!quickAssignments) {
        quickAssignments = {};
        quickAssignments[assignmentType] = {};
      }
      if (!quickAssignments[assignmentType]) {
        quickAssignments[assignmentType] = {};
      }
      if (quickAssignments[assignmentType][user.id]) {
        delete quickAssignments[assignmentType][user.id];
      }
      else {
        quickAssignments[assignmentType][user.id] = user;
      }
      const active = assignmentType != 'none' && !_.isEmpty(quickAssignments[assignmentType]);
      this.setState({ quickAssignments, active });
    }
  }

  createUserAssignments() {
    let { project, quickAssignments, assignmentType, mode } = this.state;
    const { currentCompany, isVendorBuildOwner } = this.props;
    if (!project || !project.users || !project.users.length) {
      return null;
    }
    else {
      let userRows = [];
      let userRow = [];
      let count = 0;
      if (!assignmentType && mode == 'usersOnly') {
        assignmentType = 'none';
      }
      project.users.forEach(user => {
        let addUser = true;
        if (isVendorBuildOwner && user.companies[0].id == currentCompany.id) {
          addUser = false;
        }
        if (addUser) {
          let userDisplay;

          let alreadySelected = false;
          if (mode != 'usersOnly' && quickAssignments && assignmentType != 'task-notify' && assignmentType != 'build-notify') {
            for (let type in quickAssignments) {
              if (type && type != 'task-notify' && type != 'build-notify' && type != assignmentType && quickAssignments[type][user.id]) {
                alreadySelected = true;
                break;
              }
            }
          }
          userDisplay = <div className='user' key={user.id}>
            <div className='user-avatar-container'>
              <UserAvatar
                handleSelected={this.handleUserSelected}
                larger={true}
                user={user}
                selectedBlue={alreadySelected || (quickAssignments && quickAssignments[assignmentType] && quickAssignments[assignmentType][user.id])}
                disabledWithOpacity={alreadySelected}
              />
            </div>
            <div className='user-name'>
              {user.name ? user.name : user.first_name + ' ' + user.last_name}
            </div>

          </div>;

          userRow.push(userDisplay);
          if (userRow.length == 4) {
            userRows.push(
              <div className='user-assignments-row' key={count++}>
                {userRow}
              </div>
            );
            userRow = [];
          }
        }
      });
      if (userRow.length) {
        userRows.push(
          <div className='user-assignments-row' key={userRows.length}>
            {userRow}
          </div>
        );
      }
      return userRows;
    }
  }

  handleAssign() {
    const { quickAssignments } = this.state;

    this.collapsePopup(null, true);

    if (quickAssignments) {
      dataModel.usersDAO.quickAssignments = quickAssignments;
      const currentPath = this.props.history.getCurrentLocation().pathname;
      const currentPathLowercase = currentPath.toLowerCase();
      if (quickAssignments['build-owner'] || quickAssignments['build-notify']) {
        const newPath = '/projects/' + this.state.project.id + '/bulk-assign';
        this.props.history.push(newPath);
      }
      else if (currentPathLowercase.includes('/build') && !currentPathLowercase.includes('all')) {
        let buildPath = currentPath.substr(currentPathLowercase.indexOf('/build'));
  
        let segments = buildPath.split('/');
        for (let segment of segments){
          let buildId = parseInt(segment, 10);
          if (buildId) {
            const newPath = '/projects/' + this.state.project.id + '/bulk-assign/build/' + buildId;
            this.props.history.push(newPath);
            break;
          }
        }
      }
      else {
        this.props.history.push('/projects/' + this.state.project.id + '/bulk-assign/build/all');
      }
    }
  }

  render() {
    const { isVendorBuildOwner } = this.props;
    const { assignmentType, mode } = this.state;
    let assignmentArray = null;
    if (!isVendorBuildOwner) {
      if (mode == 'usersOnly') {
        assignmentArray = <div className='assignments-grid'>
          <div className='assignments-row'>
            <div className={'assignment-type' + (assignmentType == 'field_user' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('field_user'); }}>
              <div className={'assignment-type-icon field_user'}>
              </div>
              <div className={'assignment-type-caption'}>
                Assigned To
          </div>
            </div>
            <div className={'assignment-type' + (assignmentType == 'reviewer' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('reviewer'); }}>
              <div className={'assignment-type-icon reviewer'}>
              </div>
              <div className={'assignment-type-caption'}>Reviewer</div>
            </div>
          </div>
          <div className='assignments-row'>
            {/* NOTE: commented out so it can enable it easily if needed
            <div className={'assignment-type' + (assignmentType == 'approver' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('approver') }}>
              <div className={'assignment-type-icon approver'}>
              </div>
              <div className={'assignment-type-caption'}>
                Approver
            </div>
            </div> */}
            <div className={'assignment-type' + (assignmentType == 'build-owner' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('build-owner'); }}>
              <div className={'assignment-type-icon build-owner'}>
              </div>
              <div className={'assignment-type-caption'}>Build Owner</div>
            </div>
            <div className={'assignment-type' + (assignmentType == 'task-notify' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('task-notify'); }}>
              <div className={'assignment-type-icon task-notify'}>
              </div>
              <div className={'assignment-type-caption'}>Task Notify</div>
            </div>
          </div>
          <div className='assignments-row'>
            <div className={'assignment-type' + (assignmentType == 'build-notify' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('build-notify'); }}>
              <div className={'assignment-type-icon build-notify'}>
              </div>
              <div className={'assignment-type-caption'}>Build Notify</div>
            </div>
          </div>
        </div>;
      }
      else {
        assignmentArray = <div className='assignments-grid'>
          <div className='assignments-row'>
            <div className={'assignment-type' + (assignmentType == 'field_user' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('field_user'); }}>
              <div className={'assignment-type-icon field_user'}>
              </div>
              <div className={'assignment-type-caption'}>Assigned To</div>
            </div>
            <div className={'assignment-type' + (assignmentType == 'reviewer' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('reviewer'); }}>
              <div className={'assignment-type-icon reviewer'}>
              </div>
              <div className={'assignment-type-caption'}>Reviewer</div>
            </div>
          </div>
          <div className='assignments-row'>
            {/* NOTE: commented out so it can enable it easily if needed
            <div className={'assignment-type' + (assignmentType == 'approver' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('approver'); }}>
              <div className={'assignment-type-icon approver'}>
              </div>
              <div className={'assignment-type-caption'}>Approver</div>
            </div> */}
            <div className={'assignment-type' + (assignmentType == 'task-notify' ? ' selected' : '')}
              onClick={e => { this.handleSelectAssignmentType('task-notify'); }}>
              <div className={'assignment-type-icon task-notify'}>
              </div>
              <div className={'assignment-type-caption'}>Task Notify</div>
            </div>
          </div>
        </div>;
      }
    }
    else {
      assignmentArray = <div className='assignments-grid'>
        <div className='assignments-row'>
          <div className={'assignment-type' + (assignmentType == 'field_user' ? ' selected' : '')}
            onClick={e => { this.handleSelectAssignmentType('field_user'); }}>
            <div className={'assignment-type-icon field_user'}>
            </div>
            <div className={'assignment-type-caption'}>Assigned To</div>
          </div>
          <div className={'assignment-type' + (assignmentType == 'reviewer' ? ' selected' : '')}
            onClick={e => { this.handleSelectAssignmentType('reviewer'); }}>
            <div className={'assignment-type-icon reviewer'}>
            </div>
            <div className={'assignment-type-caption'}>Reviewer</div>
          </div>
        </div>
        <div className='assignments-row'>
        <div className={'assignment-type' + (assignmentType == 'task-notify' ? ' selected' : '')}
            onClick={e => { this.handleSelectAssignmentType('task-notify'); }}>
            <div className={'assignment-type-icon task-notify'}>
            </div>
            <div className={'assignment-type-caption'}>Task Notify</div>
          </div>
        </div>
      </div>;
    }
    const usersToAssign = this.createUserAssignments();
    return (
      <article
        className='quicker-assign-popup'
        ref={el => this.quickerAssignPopup = el}
      >
        <header className='quicker-assign-popup__header'>
          <div className='caption'>
            ASSIGN PROJECT MEMBERS
            </div>
          <div className='close-button'>
            <img
              src={cancelIcon}
              alt="cancel"
              className='close-button'
              onClick={this.collapsePopup}
            />
          </div>
        </header>
        <div className='quicker-assign-popup__container'>
          <div className='assignment-types'>
            <div className='assignment-types-header'>
              ASSIGNMENT TYPE
            </div>
            {/* <div className="switch-modes">
              <CheckBox className="switch-modex-checkbox" key='switch-modes' small={true} checked={this.state.mode == 'multipleAssignmentTypes'}
                toggleCheckBox={this.handleModeToggle} />
              <div className="switch-modes-text">Multiple Assignment Types</div>
            </div> */}
            {assignmentArray}
          </div>
          <div className='user-assignments'>
            <div className='user-assignments-header'>
              SELECT USER(S)
            </div>
            <div className='user-assignments-grid'>
              {usersToAssign}
            </div>
          </div>
        </div>
        <div className='quicker-assign-popup__button-container'>
          <button
            className={'cancel-button'}
            onClick={this.collapsePopup}
          >
            CANCEL
        </button>
          <button
            className={'assign-button' + (this.state.active ? ' active' : '')}
            onClick={this.state.active ? this.handleAssign : null}
          >
            ASSIGN
          </button>
        </div>
      </article>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    quickAssignments: state.new_users.quickAssignments,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    needsLogin: state.main ? state.main.needsLogin : null,
  };
};

export default withRouter(connect(mapStateToProps)(QuickerAssignPopup));



// WEBPACK FOOTER //
// ./src/components/QuickerAssignPopup/index.js